import CryptoJS from 'crypto-js';
import type { HTMLAttributes } from 'react';

export const removeComponentProps = <T extends HTMLAttributes<HTMLElement>>(
  props: T = {} as T,
  keysToRemove: Array<keyof T>
): Omit<T, keyof T> => {
  const result = { ...props };

  keysToRemove.forEach((key) => {
    delete result[key];
  });

  return result;
};

export const generateHashByObject = (obj: Record<string, unknown>): string => {
  const jsonString = JSON.stringify(obj);

  return CryptoJS.SHA256(jsonString).toString();
};

export const isEmptyObject = <T extends object>(obj: T): boolean => Object.keys(obj).length === 0;
